/** Tranzila Bit: minimum charge in ILS (hosted-fields docs). */
export const BIT_MIN_ILS = 5
